import { useQuery } from "@apollo/client"
import { useMemo } from "react"
import { BITKUB_EXECUTION } from "src/graphql/queries/bitkubExecution"
import { bitkubExecutionQuery } from "src/types/bitkub-execution-types"

interface hookProps {
  executionID?:string
}

const useBitkubExecutionQuery = (props:hookProps) => {
  const { data:BitkubExecution,...query } = useQuery<bitkubExecutionQuery>(BITKUB_EXECUTION,{
    variables:{
      executionID:props.executionID
    },
    skip: props.executionID === ""
  })

  const data = useMemo(()=>{
    if (BitkubExecution?.bitkubExecution?.__typename === "BitkubExecution") {
      return BitkubExecution.bitkubExecution
    }
  },[BitkubExecution])

  const gridDetail = useMemo(()=>{
    if (data?.detail.__typename === "Grid") {
      return data.detail
    }
  },[data])

  const limitDetail = useMemo(()=>{
    if (data?.detail.__typename === "Limit") {
      return data.detail
    }
  },[data])

  const error = useMemo(()=>{
    if (BitkubExecution?.bitkubExecution?.__typename === "Error") {
      return BitkubExecution.bitkubExecution
    }
  },[BitkubExecution])

  const [buyCount,sellCount,currencyPosition,ThbPosition] = useMemo(()=>{
    let buyCount = 0;
    let sellCount = 0;
    let currencyPosition = 0;
    let ThbPosition = 0;

    gridDetail?.openOrders.forEach((openOrder)=>{
      if (openOrder.side === "SELL") {
        sellCount = sellCount+1
        currencyPosition = currencyPosition + openOrder.amount
      }
      if (openOrder.side === "BUY") {
        buyCount = buyCount+1
        ThbPosition = ThbPosition + openOrder.amount
      }
    })

    return [buyCount,sellCount,currencyPosition,ThbPosition]

  },[gridDetail])

  return {
    data,
    gridDetail,
    limitDetail,
    buyCount,
    sellCount,
    currencyPosition,
    ThbPosition,
    error,
    query
  }

}

export default useBitkubExecutionQuery